<div class="link-container">
    @if (icon) {
    <button (click)="onClick($event)" [matTooltip]="tooltipKey ? (tooltipKey | translate) : ''"
        [matTooltipDisabled]="!tooltipKey" [style.color]="getLinkColor()" class="link-button with-icon">
        <mat-icon>{{ icon }}</mat-icon>
        <span class="link-text">{{ getDisplayValue() }}</span>
    </button>
    } @else {
    <button (click)="onClick($event)" [matTooltip]="tooltipKey ? (tooltipKey | translate) : ''"
        [matTooltipDisabled]="!tooltipKey" [style.color]="getLinkColor()" class="link-button">
        {{ getDisplayValue() }}
    </button>
    }
</div>